import React from 'react'
import { Trans } from 'src/translations'

export const SmsMarketingLegalDisclaimer = ({
  style
}: {
  style?: React.CSSProperties
}) => {
  return (
    <div
      style={style}
      className='legal-disclaimer'
      data-testid='sms-marketing-legal-disclaimer'
    >
      <Trans
        i18nKey='sms-marketing-legal-disclaimer.legal-text'
        components={{
          TermsLink: (
            <a
              style={style}
              className='underline'
              rel='noopener noreferrer'
              target='_blank'
              href='https://pos.toasttab.com/terms-of-service'
            />
          ),
          PrivacyLink: (
            <a
              style={style}
              className='underline'
              rel='noopener noreferrer'
              target='_blank'
              href='https://pos.toasttab.com/privacy'
            />
          ),
          CALink: (
            <a
              style={style}
              className='underline'
              rel='noopener noreferrer'
              target='_blank'
              href='https://pos.toasttab.com/privacy#addendum-a'
            />
          )
        }}
      />
    </div>
  )
}
